// Vuex
import { defaultObj } from './state'

export default {
  updateMaritalData (state, data) {
    if (data.isMarried !== undefined) {
      state.isMarried = data.isMarried
    }

    if (data.spousesName !== undefined) {
      state.spousesName = data.spousesName
    }

    if (data.spousesAddress !== undefined) {
      state.spousesAddress = data.spousesAddress
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
